// extracted by mini-css-extract-plugin
module.exports = {"root":"📦ContactMutationSideEffectWarning__root--20pZU","warning":"📦ContactMutationSideEffectWarning__warning--1ElXo","body":"📦ContactMutationSideEffectWarning__body--uh-Ui"};